<template>
    <div>
        <config-main-title>
            Download de Resultados
        </config-main-title>

        <!-- Filtros -->
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <!-- Periodo -->
                     <template v-if="padrao == 'T' || ( padrao != 'S' ) ">
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select"
                                placeholder="Liberação"
                                icon="fa-solid fa-calendar-check fa-fw"
                                :optionsList="[
                                    { id: 'atend', search: 'Atendimento' }, 
                                ]"
                                optionsData="id"
                                v-model="filtros.tipo_data" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-periodo v-if="false" />
                            <az-input   
                                icon="fa-solid fa-greater-than-equal fa-fw"
                                type="date"
                                v-model="referencia" />
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input   
                                icon="fa-solid fa-less-than-equal fa-fw"
                                type="date"
                                v-model="referencia_final" />
                        </div>

                        <div class="col col-12 col-md-4" v-if="false && lista_origens.length">
                            <az-input   
                                type="select"
                                icon="fa-solid fa-location-dot fa-fw"
                                v-model="filtros.id_apoiado_origem"
                                :optionsList="lista_origens"
                                optionsData="id_apoiado_origem"
                                placeholder="Local..." />
                        </div>

                        <div class="col col-12 col-md-6">
                            <az-input   
                                icon="fa fa-search fa-fw"
                                v-model="filtros.pesquisa" 
                                placeholder="Pesquisa...">
                                <template v-slot:buttonposb>
                                    <print-export :dados="info_tabela" :left="true" printid="impressao" />
                                </template>
                            </az-input>
                        </div>
                     </template>

                     <template v-else>
                        <div class="col col-12 col-md-2">
                            <az-input   
                                icon="fa-regular fa-calendar-check fa-fw"
                                type="date"
                                v-model="referencia" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- Fim Header -->

        <div class="progress mt-1 mb-3">
            <div
                class="indeterminate"
                v-if="$store.state.loading && dados"
            ></div>
            <div class="determinate" v-else></div>
        </div>

        <div class="mb-3">
            <az-submit color="primary" @click="exportar_klis()">
                <i class="fa-solid fa-download fa-fw mr-2"></i>
                Resultados
            </az-submit>

            <JsonExcel 
                v-if="false"
                class="btn btn-success ml-2" 
                type="csv"
                :data="exibicao">
                <i class="fa-solid fa-file-csv fa-fw mr-2"></i>
                Baixar CSV
            </JsonExcel> 
            
            <button 
                v-if="padrao == 'N'"
                class="btn btn-secondary ml-1" 
                @click="exportar_klis('nephrosys')">
                <i class="fa-solid fa-file-arrow-down mr-2"></i>
                Baixar TXT
            </button>
        </div>

        <div v-if="info_tabela && info_tabela.length > 0" class="mt-3" id="impressao">

            <span class="small text-muted">{{ exibicao.length }} / {{ info_tabela.length }}</span>

            <table class="table table-hover table-responsive bg-white table-bordered small">
                <thead>
                    <tr>
                        <template v-for="(key, index) in Object.keys(info_tabela[0])">
                            <th :key="index" v-if="key.slice(-12) != '-normalidade'">
                                {{ key }}
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in exibicao" :key="index">
                        <template v-for="(value, key) in item">
                            <td :key="key" v-if="key.slice(-12) != '-normalidade'" :class="key == 'COND' ? cor_condicao(item) : ''">
                                <span v-html="simbolo_normalidade(item, key)"></span>
                                <a href="#" @click.prevent="filtrar(value)" class="card-link">
                                    {{ value }}
                                </a>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>

        <br><br><br><br><br>
    </div>
</template>

<script>
import _ from "lodash";
// import $ from "jquery";
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzInput from "../shared/forms/AzInput.vue";
import AzSubmit from "../util/AzSubmit.vue";
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue'; 
import PrintExport from '../shared/PrintExport.vue';

export default {
    data() {
        return {
            dados: null,
            referencia: this.$util.hoje(),
            referencia_final: this.$util.hoje(),
            id_terceiro: "",
            search: "",
            agora: null,
            edicao: null,
            terceiros: [],
            marcacoes: [],
            stopChunkMarcacoes: false,
            filtros: { 
                id_unidade_operacao: "", 
                id_apoiado: "", 
                id_apoiado_origem: "", 
                padrao: "", 
                pesquisa: "", 
                tipo_data: "", 
            },
            info_tabela: null, 
        };
    },

    components: {
        AzInput,
        AzSubmit, 
        AzPeriodo, 
        ConfigMainTitle, 
        PrintExport
    },

    computed: { 
        lista_origens: function () { 
            if ( this.$store.state.user.model && this.$store.state.user.model.origens ) { 
                return this.$store.state.user.model.origens;
            }
            
            return [];
        },

        padrao: function () { 
            if ( this.$store.state.user.model ) {
                return this.$store.state.user.model.st_tipo_acesso;
            }

            return 'smart';
        }, 

        exibicao: function () { 
            if ( !this.info_tabela || !this.info_tabela.length ) 
                return [];

            let reg = this.$util.getregex(this.filtros.pesquisa);

            return this.info_tabela.filter(item => ( !this.filtros.pesquisa || reg.test(JSON.stringify(item)) ));
        }
    },

    methods: {
        cor_condicao (item) { 
            switch (item.COND) {
                case 'Normal': 
                    return 'table-success';
                case 'Crítico': 
                    return 'table-danger';
                case 'Alterado': 
                    return 'table-warning';
                case 'Atenção': 
                    return 'table-info';
                default: 
                    return '';
            }
        },

        simbolo_normalidade (item, key) { 
            let normal = _.get(item, key + '-normalidade');
            let cor = "";
            let info = "";

            switch (normal) {
                case 'S': 
                    cor = 'success';
                    info = 'Normal';        
                    break;

                case 'A': 
                    cor = 'warning';
                    info = 'Alterado';        
                    break;

                case 'C': 
                    cor = 'danger';
                    info = 'Critico';        
                    break;

                case 'W': 
                    cor = 'info';
                    info = 'Atenção';        
                    break;
            }

            if ( cor ) { 
                return `<i class="fa-solid fa-pause mr-2 text-${cor}" title="${info}"></i>`;
            }

            return ""; 
        },

        filtrar (texto) { 
            if ( this.filtros.pesquisa == '"' + texto + '"' ) { 
                this.filtros.pesquisa = '';
            } else { 
                this.filtros.pesquisa = '"' + texto + '"';
            }
        },

        exportar_klis (tipo = null) { 

            this.info_tabela = null;

            let fim = this.padrao != 'S' ? this.referencia_final : this.referencia;
            
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'exportar_klis',
                redir_api: true, 
                dados: { 
                    inicio: this.referencia,
                    fim: fim,
                    origem: this.filtros.id_apoiado_origem,
                    tipo_data: this.filtros.tipo_data,
                    tipo: tipo, 
                },
                toast: true,
                msg: 'Consulta Realizada', 
                callback: res => { 

                    // Create a URL for the Blob
                    /*
                    let type = 'application/json';

                    if ( this.filtros.padrao == 'smart' ) { 
                        type = 'application/xml';
                    }
                    */

                    if ( res && res.tabela && res.dados ) { 
                        this.info_tabela = res.dados;
                        return;
                    }

                    if ( res && Array.isArray(res) && !res.length) { 
                        return;
                    }

                    let type = 'application/xml';
                    let extensao = 'xml';

                    if ( this.padrao == 'N' ) { 
                        type = 'text/plain';
                        extensao = 'txt';
                    }
                    
                    const blob = new Blob([res], { type: type });
                    const url = window.URL.createObjectURL(blob);

                    // Create a temporary link element
                    const link = document.createElement('a');
                    link.href = url;

                    //if ( this.filtros.padrao == 'smart' ) { 
                        link.download = 'resultados_' + this.$util.hoje() + '_' + this.$util.agora() + '.' + extensao; // File name for the downloaded file
                    //} else { 
                        //link.download = 'resultados.json';
                    //}

                    // Programmatically click the link to trigger the download
                    document.body.appendChild(link);
                    link.click();

                    // Clean up the temporary URL and element
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                }

            });

        },

    },

    mounted() {
        //
    }
};
</script>